import { useState } from "react";
import { useUpdateToolMutation } from "./ToolBrowser.api";
import { addUtilityToastFailure } from "utils/addUtilityToastFailure";
import {
  EuiButton,
  EuiButtonEmpty,
  EuiFieldText,
  EuiForm,
  EuiFormRow,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiModalHeaderTitle,
  EuiTextArea,
} from "@inscopix/ideas-eui";
import { Tool } from "graphql/_Types";

interface ModalUpdateToolProps {
  id: Tool["id"];
  name: string;
  helpText: string;
  onClose: () => void;
}

export const ModalUpdateTool = ({
  id,
  name: initialName,
  helpText: initialHelpText,
  onClose,
}: ModalUpdateToolProps) => {
  const [name, setName] = useState(initialName);
  const [helpText, setHelpText] = useState(initialHelpText);
  const { mutateAsync: updateTool, isLoading } = useUpdateToolMutation();

  const handleClick = async () => {
    try {
      await updateTool({ id, name, help_text: helpText });
      onClose();
    } catch (error) {
      addUtilityToastFailure("Failed to updated tool");
    }
  };

  return (
    <EuiModal onClose={onClose}>
      <EuiModalHeader>
        <EuiModalHeaderTitle>Edit Tool</EuiModalHeaderTitle>
      </EuiModalHeader>

      <EuiModalBody>
        <EuiForm>
          <EuiFormRow label="Name">
            <EuiFieldText
              autoFocus
              placeholder="My Tool"
              value={name}
              onChange={(e) => setName(e.target.value)}
              name="name"
            />
          </EuiFormRow>
          <EuiFormRow label="Description">
            <EuiTextArea
              placeholder="Describe your tool here"
              value={helpText}
              onChange={(e) => setHelpText(e.target.value)}
              name="description"
              rows={4}
            />
          </EuiFormRow>
        </EuiForm>
      </EuiModalBody>

      <EuiModalFooter>
        <EuiButtonEmpty onClick={onClose}>Cancel</EuiButtonEmpty>

        <EuiButton
          fill
          onClick={() => void handleClick()}
          disabled={name === "" || helpText === ""}
          isLoading={isLoading}
        >
          Save
        </EuiButton>
      </EuiModalFooter>
    </EuiModal>
  );
};
